import React from 'react'
import firebaseApp from './firebaseApp'
import logo from './assets/logo.png'
import './style/profile.css'

import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ListItem from "@material-ui/core/ListItem";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

function DisplayHeaderContent(){
    const username = firebaseApp.auth().currentUser.displayName;

    return(
      <>
        <div className="headerContent">
            <img src={logo} className="App-logo" alt="logo" /> 
            <div className="headerTitle">
                Welcome <b>{username}</b> <br/>
                <hr />
                <i>How are you today?</i>
            </div>
        </div>
    </>
    );
}

function MenuLink(){
    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var username = user.displayName;
        var email = user.email;
        var photoUrl = user.photoURL;
    }

    const [open, setOpen] = React.useState(false);
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return(
        <div className="menu"> 
            <Toolbar>
                <IconButton
                    aria-label="menu"
                    onClick={handleDrawerOpen}
                    edge="start"
                    className={clsx(open && "menuHide")}
                >
                    <div className="material-icons menuIcon">menu</div>
                </IconButton>
            </Toolbar>
            <Drawer
                className="menuSection"
                anchor="left"
                onClose={handleDrawerClose}
                open={open}
                classes={{
                    paper: "menuLinkPaper",
                }}
            >
                <div className ="expandMenuSection" >
                    <div className="menuLinkHeader">
                        <IconButton onClick={handleDrawerClose}>
                            <MenuIcon className="menuIconStyle"/>
                        </IconButton>
                    </div>
                    <div className="displayUserInformation">
                        <div className="googleProfilePicSection">
                            <img alt="profile pic icon" src={photoUrl} className="googleProfilePic" />
                            <Link to ="/profile">
                                <div className="btnView"><p>View</p></div>
                            </Link>
                        </div>
                        <div className="loginDetails">
                            <h3 className="username">{username} </h3>
                            <h5 className="emailAddress"><i>{email}</i></h5>
                        </div>
                    </div>
                    <Divider />
                    <List className="listSection">
                        <ListItemLink className="menuLink" href="/dashboard">
                            DASHBOARD
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/securityEvents">
                            SECURITY EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/emailList">
                            BLACKLIST / WHITELIST
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/events">
                            YOUR EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/policy">
                            OUR POLICY
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/newUserSetup">
                            INSTALLATION
                        </ListItemLink>
                    </List>
                </div>
            </Drawer>
        </div>
    );
}

function DisplayProfileDetails(){

    const user = firebaseApp.auth().currentUser;

    var providerId, profileUid;
    if (user != null) {
        var username = user.displayName;
        var email = user.email;
        var photoUrl = user.photoURL;
        
        user.providerData.forEach(function (profile) {
            providerId = profile.providerId;
            profileUid = profile.uid;
        });
    }
    
    return (
        <div className="profilePicSection">
            <div className="profileIcon"> 
                <img alt="profile pic icon" src={photoUrl} className="enlargeGoogleProfilePic" />
            </div>
            <div className="detailSection">
                <b>Sign-in provider: </b> <i>{providerId}</i> <br /><br />
                <b>Provider-specific UID: </b> <i>{profileUid}</i> <br /><br />
                <b>Username : </b> <i>{username}</i> <br /><br />
                <b>Email Address: </b> <i>{email}</i> 
            </div>
        </div>
    );
}

function Logout(){
    return(
        <div className="btnLogout">
            <IconButton
            aria-label="exit icon"
            edge="start"
            href="/logout"
            >
                <div className="material-icons exitIcon">
                    exit_to_app
                </div>
            </IconButton>
        </div>
    );
}

function Copyright()
{
    return (
      <>
        {'Copyright © '}
        <Link to="https://isitphishy.wixsite.com/website" target="_blank">
            Phishy
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </>
    );
}

function EmailList() 
{
    
    return (
        <>
        <div className="topSectionBackground">
            <div className="topContentBackground">
              <DisplayHeaderContent />
              <MenuLink />
              <Logout />
          </div>
        </div>
        <div className="profileContainer">
            <Typography component="h1"> MY PROFILE </Typography>
            <DisplayProfileDetails />
        </div>
        <div className="footer">
            <Copyright />
        </div>
        </>
    )
}
export default EmailList;
